var Layred = (function () {
  var handleTextChar = function () {
    var wordRoateElements = document.querySelectorAll('.word-rotate');
    wordRoateElements.forEach((data, _) => {
      var wordRoate = $(data).text().split('');
      const step = 360 / wordRoate.length;
      wordRoate.forEach((el, i) => {
        $(data)
          .closest('.word-rotate-box')
          .append('<span class="text__char" style="--char-rotate :' + i * step + 'deg">' + el + '</span>');
      });
      $(data).remove();
    });
  };

  var handleLightGallery = function () {
    if (jQuery('#lightgallery').length > 0) {
      lightGallery(document.getElementById('lightgallery'), {
        plugins: [lgThumbnail, lgZoom, lgVideo],
        selector: '.lg-item',
        thumbnail: true,
        exThumbImage: 'data-src',
      });
    }
  };

  var handleShowPassword = function () {
    $('.dz-search-password .show-pass').on('click', function () {
      $(this).parent().toggleClass('show');
      if ($(this).parent().hasClass('show')) {
        $(this).parent().find('input').attr('type', 'text');
      } else {
        $(this).parent().find('input').attr('type', 'password');
      }
    });
  };

  var handleResizeElement = function () {
		var headerTop = 0;
		var headerNav = 0;

		$('.header .sticky-header').removeClass('is-fixed');
		$('.header').removeAttr('style');

		if (jQuery('.header .top-bar').length > 0 && screenWidth > 991) {
			headerTop = parseInt($('.header .top-bar').outerHeight());
		}

		if (jQuery('.header').length > 0) {
			headerNav = parseInt($('.header').height());
			headerNav = (headerNav == 0) ? parseInt($('.header .main-bar').outerHeight()) : headerNav;
		}

		var headerHeight = headerNav + headerTop;

		jQuery('.header').css('height', headerHeight);
	}

  var headerFix = function () {
		/* Main navigation fixed on top  when scroll down function custom */
		jQuery(window).on('scroll', function () {
			if (jQuery('.sticky-header').length > 0) {
				var menu = jQuery('.sticky-header');
				if ($(window).scrollTop() > menu.offset().top) {
					menu.addClass('is-fixed');
				} else {
					menu.removeClass('is-fixed');
				}
			}
		});
		/* Main navigation fixed on top  when scroll down function custom end*/
	}


  /* Function ============ */
  return {
    init: function () {
      handleTextChar();
      handleLightGallery();
      handleShowPassword();
      headerFix();
    },

    load: function () {
      handleResizeElement();
    },

    scroll: function () {},

    resize: function () {
      handleResizeElement();
    },
  };
})();

/* Document.ready Start */
jQuery(document).ready(function () {
  'use strict';
  Layred.init();
});
/* Document.ready END */

/* Window Load START */
jQuery(window).on('load', function () {
  'use strict';
  Layred.load();
});
/*  Window Load END */

/* Window Resize START */
jQuery(window).on('resize', function () {
  'use strict';
  Layred.resize();
});
/*  Window Resize END */

/* Window scroll START */
jQuery(window).on('scroll', function () {
  'use strict';
  Layred.scroll();
});
/*  Window scroll END */

// ─── Scroll Lock Fix: Collection Filter ──────────────────────────────────────
// global.js or menu-drawer locks body scroll. This safely restores it
// after every filter AJAX update without breaking cart/drawer behavior.

(function () {
  var LOCK_CLASSES = ['overflow-hidden', 'scroll-lock', 'no-scroll', 'is-locked', 'overflow-y-hidden'];

  function restoreBodyScroll() {
    LOCK_CLASSES.forEach(function (cls) {
      document.body.classList.remove(cls);
      document.documentElement.classList.remove(cls);
    });
    document.body.style.overflow = '';
    document.body.style.overflowY = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
  }

  // Only run on collection pages
  if (!document.getElementById('ProductGridContainer')) return;

  // ── Patch FacetFiltersForm after it's defined ──────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {

    // 1. After AJAX fetch render
    if (typeof FacetFiltersForm !== 'undefined') {
      var origFetch = FacetFiltersForm.renderSectionFromFetch;
      FacetFiltersForm.renderSectionFromFetch = function (url, event) {
        var result = origFetch.call(this, url, event);
        // fetch() is async — wait for it then restore scroll
        if (result && typeof result.then === 'function') {
          result.then(restoreBodyScroll);
        } else {
          setTimeout(restoreBodyScroll, 50);
        }
        return result;
      };

      // 2. After cache render (synchronous)
      var origCache = FacetFiltersForm.renderSectionFromCache;
      FacetFiltersForm.renderSectionFromCache = function (filterDataUrl, event) {
        origCache.call(this, filterDataUrl, event);
        restoreBodyScroll();
      };
    }

    // 3. Any facet checkbox change → restore after debounce + render settle
    document.addEventListener('change', function (e) {
      if (e.target && e.target.classList.contains('facet-input')) {
        setTimeout(restoreBodyScroll, 950); // 800ms debounce + 150ms render buffer
      }
    });

    // 4. Active filter pill removed (facet-remove click)
    document.addEventListener('click', function (e) {
      if (e.target.closest('facet-remove')) {
        setTimeout(restoreBodyScroll, 500);
      }
    });

    // 5. Browser back/forward through filter history
    window.addEventListener('popstate', function () {
      setTimeout(restoreBodyScroll, 150);
    });

    // 6. Nuclear fallback: if body gets overflow-hidden on a collection page,
    //    auto-remove it after 1.5s (won't affect cart drawer which re-locks immediately)
    var bodyObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === 'class' || mutation.attributeName === 'style') {
          var hasLock = LOCK_CLASSES.some(function (cls) {
            return document.body.classList.contains(cls);
          });
          if (hasLock && document.getElementById('ProductGridContainer')) {
            // Only auto-remove if no drawer/modal is visibly open
            var drawerOpen = document.querySelector('.cart-drawer.active, .cart-drawer.open, [aria-modal="true"], .mobile-facets__disclosure[open]');
            if (!drawerOpen) {
              setTimeout(restoreBodyScroll, 1500);
            }
          }
        }
      });
    });

    bodyObserver.observe(document.body, { attributes: true });
  });

})();
